import { useTranslation } from 'react-i18next'

import { SEARCH_RESULTS_FLATS_ENTITY } from '../../../constants/entity'
import {
  ROUTE_PATH_LIST,
  SUBMENU_DEFAULT_VALUE,
} from '../../../constants/route'
import { FlatTableLayout, useFlatTablePage } from '../../Flat'
import { useSearchResultsTableOptions } from '../SearchResults.hooks'
import { getSearchResultsBreadcrumbs } from '../SearchResults.utils'
import { SearchResultsPage } from '../SearchResultsPage'

import { updateSearchResultsFlatsTableConfig } from './SearchResultsFlats.api'
import {
  QA_NAME_SEARCH_RESULTS_FLATS_TABLE,
  SEARCH_RESULTS_FLATS_CONFIG_API,
  SEARCH_RESULTS_FLATS_LIST_API,
} from './SearchResultsFlats.constants'

import FlatsIcon from '../../../icons/flat.svg'

function SearchResultsFlats() {
  const { t } = useTranslation()

  const { asyncTableOptions, extraSelectionResetDeps, searchQuery } =
    useSearchResultsTableOptions({
      asyncTableOptions: {
        listApi: SEARCH_RESULTS_FLATS_LIST_API,
        tableConfigApi: SEARCH_RESULTS_FLATS_CONFIG_API,
      },
    })

  const tablePage = useFlatTablePage({
    asyncTableOptions,
    entity: SEARCH_RESULTS_FLATS_ENTITY,
    extraSelectionResetDeps,
    pageTitle: t('SearchResults.FlatsBrowserTabTitleKey'),
    sub: SUBMENU_DEFAULT_VALUE,
    onApplyTableConfig: updateSearchResultsFlatsTableConfig,
  })

  const breadcrumbs = getSearchResultsBreadcrumbs({
    leadingBreadcrumbs: [
      {
        id: 'flats',
        title: t('BrowserTab.FlatsPageTitleKey'),
        to: `/${ROUTE_PATH_LIST.flats}/`,
      },
    ],
    searchQuery,
    t,
  })

  return (
    <SearchResultsPage
      EntityIcon={FlatsIcon}
      TableLayout={FlatTableLayout}
      breadcrumbs={breadcrumbs}
      emptyText={t('Flat.NoDataKey')}
      qaName={QA_NAME_SEARCH_RESULTS_FLATS_TABLE}
      tablePage={tablePage}
    />
  )
}

export default SearchResultsFlats
